<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-tabs  v-model:activeKey="activeKey">
        <a-tab-pane :key="1" tab="店员级别设置">
          <levelList></levelList>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="成长值设置">
          <setUp></setUp>
        </a-tab-pane>
        <a-tab-pane :key="3" tab="店员类型">
          <typeList></typeList>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted,inject } from "vue";
import levelList from './components/level_list';
import typeList from './components/type_list';
import setUp from './components/set_up';
export default {
  components: {levelList,typeList,setUp },
  setup() {
    const activeKey = ref(1);
    const $route = inject('$route')
    onMounted(() => {
      activeKey.value = $route.query.active ? Number($route.query.active) : 1
    });
    return {
      activeKey
    };
  },
};
</script>